<template>
  <div class="salesContract">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :max-height="tableHeight"
      :columns="columnList"
      :edit-config="slipStatus != 'JSDZT06' ? { trigger: 'click', mode: 'row' } : ''"
      show-footer
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'salesContract',
    props: ['slipStatus'],
    components: {
      // inputNumberAd,
    },
    computed: {
      columnList() {
        //基础数据表单配置
        return [
          { type: 'seq', width: 60, title: this.$t('table.index'), fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.contractCreateDate',
            title: this.$t('batchAdd.salesContract.contractCreateDate'),
          }, //合同日期
          {
            field: 'serializationJsonData.customerName',
            title: this.$t('batchAdd.salesContract.customerName'),
          }, // 客户
          {
            field: 'serializationJsonData.contractNo',
            title: this.$t('batchAdd.salesContract.contractNo'),
          }, // 销售管理号
          {
            field: 'serializationJsonData.contractDetailNo',
            title: this.$t('batchAdd.salesContract.contractDetailNo'),
          }, // 合同行项目
          {
            field: 'serializationJsonData.externalContractNo',
            title: this.$t('batchAdd.salesContract.externalContractNo'),
          }, // 外部销售合同号
          {
            field: 'serializationJsonData.contractStatus',
            title: this.$t('batchAdd.salesContract.contractStatusName'),
            formatter: this.formatterStatus,
          }, // 合同状态
          {
            // 合同数量
            field: 'serializationJsonData.productQuantity',
            title: this.$t('batchAdd.salesContract.productQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.productQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 合同单价
            field: 'serializationJsonData.businessContractUnitPrice',
            title: this.$t('batchAdd.salesContract.businessContractUnitPrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessContractUnitPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 合同金额
            field: 'serializationJsonData.businessContractTotalAmount',
            title: this.$t('batchAdd.salesContract.businessContractTotalAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessContractTotalAmount
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.receiptCondition',
            title: this.$t('batchAdd.salesContract.receiptConditionName'),
            formatter: this.formatterReceiptCondition,
          }, // 付款条件
          {
            // 实提数
            field: 'serializationJsonData.pickedQuantity',
            title: this.$t('batchAdd.salesContract.pickedQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.pickedQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 应收款金额
            field: 'serializationJsonData.collectableAmount',
            title: this.$t('batchAdd.salesContract.collectableAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.collectableAmount
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.cutPayment',
            title: this.$t('batchAdd.salesContract.cutPayment'), // 扣款
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.cutPayment)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.serializationJsonData.cutPayment}
                    clearable={true}
                    max={9999999999.99}
                    min={0}
                    onInput={(val) => this.cutPaymentChange(val, row)}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 已收款金额
            field: 'serializationJsonData.collectedAmount',
            title: this.$t('batchAdd.salesContract.collectedAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.collectedAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 未收款金额
            field: 'serializationJsonData.unCollectAmount',
            title: this.$t('batchAdd.salesContract.unCollectAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.unCollectAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.invoiceType',
            title: this.$t('batchAdd.salesContract.invoiceType'),
            formatter: this.formatterInvoiceType,
          }, // 发票类型
          {
            field: 'serializationJsonData.goldenTaxDate',
            title: this.$t('batchAdd.salesContract.goldenTaxDate'),
          }, // 开票日期
          {
            // 可开单库存数量
            field: 'serializationJsonData.canIssuedInventoryQuantity',
            title: this.$t('batchAdd.salesContract.canIssuedInventoryQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.canIssuedInventoryQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 客户剩余可提数量
            field: 'serializationJsonData.restPickingQuantity',
            title: this.$t('batchAdd.salesContract.restPickingQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.restPickingQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.lastestReceiveMoneyDay',
            title: this.$t('batchAdd.salesContract.lastestReceiveMoneyDay'),
          }, // 应收款日期
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      formatterReceiptCondition({ cellValue }) {
        return this.$baseRequest.getDictValueByType('receipt_condition', cellValue);
      },
      formatterStatus({ cellValue }) {
        return this.$baseRequest.getDictValueByType('contract_status', cellValue);
      },
      formatterInvoiceType({ cellValue }) {
        return this.$baseRequest.getDictValueByType('invoice_type', cellValue);
      },
      cutPaymentChange(val, row) {
        row.serializationJsonData.cutPayment = val;
        this.$refs.table.updateData();
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.productQuantity',
          'serializationJsonData.businessContractTotalAmount',
          'serializationJsonData.pickedQuantity',
          'serializationJsonData.collectableAmount',
          'serializationJsonData.cutPayment',
          'serializationJsonData.collectedAmount',
          'serializationJsonData.unCollectAmount',
          'serializationJsonData.canIssuedInventoryQuantity',
          'serializationJsonData.restPickingQuantity',
          'serializationJsonData.collectableAmount',
          'serializationJsonData.collectedAmount',
          'serializationJsonData.unCollectAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              let point;
              if (column.property.indexOf('Quantity') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
